import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  constructor(private readonly http: HttpClient) {}

  getProduct(productId, email, channel, locales, defaultLocale) {
    const data = {
      productId: productId,
      channel: channel,
      locales: locales,
      locale: defaultLocale,
      email: email,
    };
    return this.http.post(`${environment.api_url}product/seller`, data);
  }

  getOperatorProductList(data): Observable<any> {
    return this.http.post<any>(`${environment.api_url}products/operator`, data);
  }

  getSellerProductList(data): Observable<any> {
    return this.http.post<any>(`${environment.api_url}products/seller`, data);
  }

  getOperatorMasterProduct(
    productId: string,
    email: string,
    channel: string,
    locales: string[],
    defaultLocale: string,
  ) {
    const data = {
      productId: productId,
      channel: channel,
      locales: locales,
      locale: defaultLocale,
      email: email,
    };
    return this.http.post(`${environment.api_url}product/operator`, data);
  }


  updateProduct(data): Observable<any> {
    return this.http.post(`${environment.api_url}product/seller/update`, data, { responseType: 'text' });
  }

  updateSingleAttribute(data): Observable<any> {
    return this.http.post(`${environment.api_url}product/operator/update`, data, { responseType: 'text' });
  } 
  
  updateOperatorMediaProduct(formData): Observable<any> {
    return this.http.post(`${environment.api_url}product/operator/update/media`, formData, {
       headers: new HttpHeaders({
        'Accept': 'application/json'
      }), 
      responseType: 'text'
    })
  }  
  
  updateSellerMediaProduct(formData): Observable<any> {
    return this.http.post(`${environment.api_url}product/seller/update/media`, formData, {
      headers: new HttpHeaders({
        'Accept': 'application/json'
      }), 
      responseType: 'text'
    })
  }

  getAttributeValue(data): Observable<any> {
    return this.http.post(`${environment.api_url}product/operator/attribute/value`, data);
  }

  exportHistory(data) {
      return this.http.post(`${environment.api_url}export/product/history`, data, { responseType: 'blob', observe: 'response' })
  }
}
